import { Activity, AlertTriangle, CheckCircle, Clock, Zap } from 'lucide-react';
import styles from './ReportPreview.module.css';

export const ReportPreview = () => {
  return (
    <section id="preview" className={styles.section}>
      <div className="wrap">
        <div className="section-header">
          <div className="section-label">Report Preview</div>
          <h2>Actionable Insights, Not Technical Jargon</h2>
          <p>Here is a sample of what your personalized AI health report looks like.</p>
        </div>

        <div className={styles.previewContainer}>
          <div className={styles.sidebar}>
            <div className={styles.scoreCard}>
              <div className={styles.scoreCircle}>
                <svg viewBox="0 0 36 36" className={styles.circularChart}>
                  <path className={styles.circleBg} d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                  <path className={styles.circle} strokeDasharray="68, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                </svg>
                <div className={styles.scoreValue}>68</div>
              </div>
              <h3>Health Score</h3>
              <p>Needs Attention</p>
            </div>

            <div className={styles.statsCard}>
              <div className={styles.statItem}>
                <Zap size={16} /> <span>CPU Load: 84% (High)</span>
              </div>
              <div className={styles.statItem}>
                <Activity size={16} /> <span>RAM Usage: 14.2GB / 16GB</span>
              </div>
              <div className={styles.statItem}>
                <Clock size={16} /> <span>Boot Time: 124s</span>
              </div>
            </div>
          </div>

          <div className={styles.mainContent}>
            <div className={styles.issueItem}>
              <div className={styles.issueHeader}>
                <div className={styles.issueLabel} data-type="critical">Critical Issue</div>
                <div className={styles.issueImpact}>Impact: -15 Points</div>
              </div>
              <h3>Background Process Bottleneck</h3>
              <p>We found 4 high-resource apps running in the background that you haven't used in 30 days. They are consuming 40% of your CPU capacity.</p>
              <div className={styles.fixAction}>
                <strong>Recommended Fix:</strong> Disable 'Updater.exe' and 'LegacyCloud.exe' from your Startup Apps.
              </div>
            </div>

            <div className={styles.issueItem}>
              <div className={styles.issueHeader}>
                <div className={styles.issueLabel} data-type="warning">Optimization</div>
                <div className={styles.issueImpact}>Impact: -8 Points</div>
              </div>
              <h3>Disk Fragmentation Warning</h3>
              <p>Your primary storage drive is 92% full, which is slowing down file access and temporary system operations.</p>
              <div className={styles.fixAction}>
                <strong>Recommended Fix:</strong> Use 'Disk Cleanup' to remove 45GB of temporary system files identified.
              </div>
            </div>

            <div className={styles.issueItem}>
              <div className={styles.issueHeader}>
                <div className={styles.issueLabel} data-type="success">Healthy</div>
              </div>
              <h3>Driver Integrity</h3>
              <p>All core hardware drivers are up to date and signed by verified manufacturers.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
